import { IconName } from '@ardoq/icons';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { header4 } from '@ardoq/typography';
import { PropsWithChildren } from 'react';
import { ViewOptionsClickableIcon } from '@ardoq/perspectives-sidebar';

const HeaderContainer = styled.div<{
  $isUnderlined?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px;
  color: ${colors.grey900};
  ${header4}

  ${({ $isUnderlined }) =>
    $isUnderlined && `border-bottom: 1px solid ${colors.grey200};`}
`;

const HeaderTitle = styled.h2`
  margin: 0;
  color: inherit;
  font: inherit;
`;

type ViewOptionsHeaderProperties = PropsWithChildren<{
  isUnderlined?: boolean;
  onCloseClick: VoidFunction;
  closeLabel?: string;
}>;

const ViewOptionsHeader = ({
  children,
  isUnderlined,
  onCloseClick,
  closeLabel = 'Close view settings',
}: ViewOptionsHeaderProperties) => (
  <HeaderContainer $isUnderlined={isUnderlined}>
    <HeaderTitle>{children}</HeaderTitle>
    <ViewOptionsClickableIcon
      iconName={IconName.CLOSE}
      onClick={onCloseClick}
      label={closeLabel}
    />
  </HeaderContainer>
);
export { ViewOptionsHeader };
